import React, { FC, useEffect, useState } from "react";
import { WiegandCard } from "./WiegandCard";
import CommsCard from "./CommsCard";
import IdemiaAdvancedCard from "./IdemiaAdvancedCard";
import { IDEMIA_SETTINGS } from "../../constants/preset-constants";
import ThreatLevelCard from "./ThreatLevelCard";
import { WIEGAND_FRAME_LENGTH, WIEGAND_ID_FORMAT, WIEGAND_SEND_ID_ENABLED, WIEGAND_SITE_CODE, WIEGAND_SITE_FORMAT, WIEGAND_START_FORMAT, WIEGAND_STOP_FORMAT,
    BIO_TCPIP_HOST_PORT, BIO_TCPIP_POOL_COUNT, BIO_TCPIP_EXTENDED_TIMEOUT, BIO_FAST_UPLOAD_MA100, BIO_FAST_UPLOAD_JSERIES, BIO_FULL_UPLOAD_RETRIES, BIO_LOGGING_THRESHOLD,
    BIO_CARD_READ_SUPPORT, BIO_SUCCESS_MESSAGE_CONTENT, BIO_TIMESYNCH_ENABLED_FULL_UPLOAD, BIO_TIMESYNCH_ENABLED_GENERAL, BIO_VERIFY_USER_ID, BIO_CHECK_HOLIDAY_SCHEDULE, BIO_ENABLE_EXTERNAL_DATABASE, BIO_CHECK_ACCESS_SCHEDULE, BIO_CHECK_EXPIRY_DATE, BIO_CHECK_STOLEN_CARD_LIST, BIO_CSN_LENGTH } from "../../constants/biometric-fields-names";
import TimeAndAttendance from "./TimeAndAttendanceCard";

interface IdemiaPresetProps {
    presetId?: string;
    idemiaPresetCardType: string
}

export const IdemiaPresets: FC<IdemiaPresetProps> = ({ presetId = '', idemiaPresetCardType }) => {
    const [content, setContent] = useState<any>([]);
    const wiegandFields = [WIEGAND_SITE_CODE, WIEGAND_ID_FORMAT, WIEGAND_SITE_FORMAT, WIEGAND_START_FORMAT, WIEGAND_STOP_FORMAT, WIEGAND_FRAME_LENGTH, WIEGAND_SEND_ID_ENABLED]
    const commsFields = [BIO_TCPIP_HOST_PORT, BIO_TCPIP_POOL_COUNT, BIO_TCPIP_EXTENDED_TIMEOUT, BIO_FAST_UPLOAD_MA100, BIO_FAST_UPLOAD_JSERIES, BIO_FULL_UPLOAD_RETRIES, BIO_LOGGING_THRESHOLD,
        BIO_CARD_READ_SUPPORT, BIO_SUCCESS_MESSAGE_CONTENT, BIO_TIMESYNCH_ENABLED_FULL_UPLOAD, BIO_TIMESYNCH_ENABLED_GENERAL, BIO_VERIFY_USER_ID, BIO_CHECK_HOLIDAY_SCHEDULE, BIO_ENABLE_EXTERNAL_DATABASE,
       BIO_CHECK_ACCESS_SCHEDULE, BIO_CHECK_EXPIRY_DATE, BIO_CHECK_STOLEN_CARD_LIST, BIO_CSN_LENGTH]

    useEffect(() => {
        setIdemiaTabContent();
    }, [presetId, idemiaPresetCardType])

    const setIdemiaTabContent = () => {
        switch (idemiaPresetCardType) {
            case IDEMIA_SETTINGS.COMMS:
                {
                    setContent([<CommsCard presetId={presetId} commsFields={commsFields} />]);
                    break;
                }
            case IDEMIA_SETTINGS.WIEGAND:
                {
                    setContent([<WiegandCard presetId={presetId} wiegandFields={wiegandFields}
                    />]);
                    break;
                }
            case IDEMIA_SETTINGS.THREAT_LEVEL:
                {
                    setContent([<ThreatLevelCard presetId={presetId} />]);
                    break;
                }
            case IDEMIA_SETTINGS.ADVANCED:
                {
                    setContent([<IdemiaAdvancedCard presetId={presetId} />]);
                    break;
                }
            case IDEMIA_SETTINGS.TIME_AND_ATTENDANCE:
                {
                    setContent([<TimeAndAttendance presetId={presetId} isControlId={false}/>]);
                    break;
                }
            default: { };
        }
    }

    return (content);
};
